module.exports = __webpack_public_path__ + "img/500.2e189c55.svg";